module.exports = __webpack_public_path__ + "img/titleen.ec7e0099.png";